<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-left">
        <h2 class="footer-title">株洲高新区企业出海服务平台</h2>
        <div class="footer-description">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;以"服务为一体"理念为引领，我们致力于为企业，走出国门提供全方位、高效、专业为企业提供全方位的企业出海服务体系建设，助推全球化，全方位的企业出海服务体系。</p>
        </div>
      </div>
      <div class="footer-right">
        <div class="qr-code">
          <img :src="require('@/images/erwm.jpg')" alt="二维码" class="qr-image">
          <p class="qr-text">关注平台</p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p class="copyright">Copyright©2022-2026 株洲高新区企业出海服务平台 版权所有 | 湘ICP备12012020号 •</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
/* 底部区域样式 */
.footer {
  background-color: #4A90E2;
  color: white;
  padding: 0;
  margin-top: 50px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 50px 30px;
}

.footer-left {
  flex: 1;
  max-width: 600px;
}

.footer-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 20px 0;
  letter-spacing: 1px;
}

.footer-description {
  line-height: 1.6;
  width: 330px;
}

.footer-description p {
  margin: 0 0 5px 0;
  font-size: 14px;
  opacity: 0.95;
  letter-spacing: 0.3px;
}

.footer-right {
  display: flex;
  align-items: flex-start;
  margin-left: 40px;
}

.qr-code {
  text-align: center;
}

.qr-image {
  width: 100px;
  height: 100px;
  margin-bottom: 8px;
  border: 3px solid white;
  border-radius: 4px;
  display: block;
}

.qr-text {
  font-size: 12px;
  margin: 0;
  opacity: 0.9;
}

.footer-bottom {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright {
  margin: 0;
  font-size: 12px;
  opacity: 0.8;
  letter-spacing: 0.5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 30px 20px;
  }
  
  .footer-right {
    margin-left: 0;
    margin-top: 20px;
  }
  
  .footer-title {
    font-size: 20px;
  }
  
  .footer-description p {
    font-size: 13px;
  }
}
</style>